import { render } from "./FlickitySlider.vue?vue&type=template&id=74d1e7aa&scoped=true"
import script from "./FlickitySlider.vue?vue&type=script&lang=js"
export * from "./FlickitySlider.vue?vue&type=script&lang=js"

import "./FlickitySlider.vue?vue&type=style&index=0&id=74d1e7aa&lang=scss&scoped=true"
import "./FlickitySlider.vue?vue&type=style&index=1&id=74d1e7aa&lang=scss"

import exportComponent from "/home/runner/work/eni-dist_longform-just-transition-persone/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d1e7aa"]])

export default __exports__